

































































































































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import VueBase from '@/components/VueBase';
import { debounce } from 'lodash';
import { Client, ClientData } from '@/models/Clients/Client';
import DataTable from '@/components/Common/DataTable.vue';
import { CountryService } from '@/services/CountryService';
import { CompanyService } from '@/services/CompanyService';
import { ClientService } from '@/services/ClientService';
import Option from '@/models/Option';
import { Country } from '@/models/Countries/Country';
import { State } from '@/models/Countries/State';
import { QuestelEntity } from '@/models/Companies/QuestelEntity';
    import { Ref, Watch } from 'vue-property-decorator';
    import FileSaver, { saveAs } from 'file-saver';
import { UnitaryPatentConstants } from '@/constants/UnitaryPatentConstants'
import PageList from '@/models/Pagination/PageList';
import ListPageBase from '@/components/ListPageBase';
@Component({
  components: {
    DataTable
  }
})
export default class Clients extends ListPageBase {
  @Ref('formElement') private readonly formElement: any;

    private rules: any = { ...UnitaryPatentConstants.validationRules };
    private digitRules: any = { ...UnitaryPatentConstants.customerIdRules };
  private addOrEditClient: boolean = false
  private tableLoading: boolean = false;
  private selectedClientFilter: string = '';

  private countryList: Option[] = [];
    private questelEntityList: Option[] = [];
    private file: File | any = null;
    private loadingModule: boolean = false;
    private loadingFile: boolean = false;
    private deleteFile: boolean = false;

  private countryService: CountryService = new CountryService();
  private companyService: CompanyService = new CompanyService();
    private clientService: ClientService = new ClientService();
    private menu: boolean = false;
    private date: any = null;
    private activePicker: any = null;
    private acceptedFileRule(v): any {
        if (!v || v.size === 0) {
            return true; // Allow empty files
        }

        const allowedTypes = ['application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/pdf'];

        return allowedTypes.includes(v.type) || 'Selected invalid file. Please select pdf/doc/docx file only.';
    }

  private get defaultHeaders(): Array<any> {
    return [
      { 
        text: "First Name",
        value: "Firstname",
        align: "start",
        sortable: false,
        width: "10%"
      },
      { 
        text: "Last Name",
        value: "Lastname",
        align: "start",
        sortable: false,
        width: "10%"
      },
      { 
        text: "Company",
        value: "Company",
        align: "start",
        sortable: false,
        width: "15%"
      },
      { 
        text: "Address",
        value: "Address",
        align: "start",
        sortable: false,
        width: "30%"
      },
      { 
        text: "Customer ID",
        value: "CustomerId",
        align: "start",
        sortable: false,
        width: "10%"
      },
      { 
        text: "Email",
        value: "Email",
        align: "start",
        sortable: false,
        width: "20%"
      },
      { 
        text: "Actions",
        value: "Actions",
        align: "center",
        sortable: false,
        width: "5%"
      }
    ]
  }

  get formTitle(): string {
    return !this.defaultClient.Id ? 'New' : 'Edit';
    }

    get loaderProgess(): boolean {
        return this.loadingFile;
    }

    private columnForDeletion(): number {
        if (this.deleteFile) {
            return 12;
        }
        else {
            return 3;
        }
    }

  searchChanged = debounce(val => {
    this.updateSearch(val);
  }, 500);

    private updateSearch(val: string) {
    this.selectedClientFilter = val;
    this.onPageChanged(1);
  }

  private defaultClient: Client = {
  };
  
  async mounted(): Promise<void> {
    await this.loadInit();
  }

  onPageChanged(pNumber: number): void {
    this.pageNumber = pNumber;
    this.updatePageData();
  }

  onPageSizeChanged(pSize: number): void {
    this.pageSize = pSize;
    this.updatePageData();
  }

  async loadData(): Promise<void> {
    var countryListResult = await this.countryService.getCountryList();
    this.countryList = countryListResult.map((item: Country) => ({
      text: item.CountryName,
      value: item.CountryId
    }));

    var questelEntityListResult = await this.companyService.getQuestelEntityList();
    this.questelEntityList = questelEntityListResult.map((item: QuestelEntity) => ({
      text: item.QuestelEntityName,
      value: item.QuestelEntityId
    }));
  }

  private onAddClient(): void {
    this.addOrEditClient = true;
  }

  private onRowEdit(item: Client): void {
    this.defaultClient = { ...item };
    this.addOrEditClient = true;
    }

    private downloadDeclaration(clientId: Guid) {
        this.loadingModule = true;
        this.loadingFile = true;
        this.clientService.downloadGeneralDeclaration(clientId)
            .then(success => {
                var filename = '';
                var disposition = success.headers.get('Content-Disposition');
                var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                var matches = filenameRegex.exec(disposition);

                if (matches != null && matches[1]) {
                    filename = matches[1].replace(/['"]/g, '');
                }
                success.blob().then((b: any) => {
                    FileSaver.saveAs(b, decodeURIComponent(filename));
                });
            })
            .catch(error => {
                this.loadingModule = false;
                this.loadingFile = false;
            }).finally(() => {
                this.loadingModule = false;
                this.loadingFile = false;
            });
    }

  private async onSaveClient(): Promise<void> {
    if (!this.formElement.validate()) {
      return;
      }
      var selectedFile = (this.file as File);
      var data = new FormData();
      if(this.file)
          data.append("file", selectedFile);
      else
          data.append("file", null);

    if(!this.defaultClient.Id) {
      this.clientService.addClient(this.defaultClient)
      .then(success => {
          if (success.Success) {
              if (this.file || this.deleteFile == true) {
                  this.clientService.updateFile(success.Data.Id, data, this.deleteFile).then(success => {
                      if (success.Success) {
                          this.deleteFile = false;
                      }
                  });
              }
              this.addOrEditClient = false;
            this.updatePageData();
        }
      })
          .catch(err => { this.displayErrorMessage(err.Message); });
    }
    else{
      this.clientService.updateClient(this.defaultClient)
      .then(success => {
        if(success.Success) {
          const selectedCountry = this.countryList.find(x => x.value == this.defaultClient.CountryId.toString());
            this.defaultClient.CountryName = selectedCountry.text;
            this.pagedData.Data.filter(d => d.Id === this.defaultClient.Id).forEach(item => {
                Object.assign(item, { ... this.defaultClient });
                if (this.file || this.deleteFile == true) {
                  this.clientService.updateFile(success.Data.Id, data, this.deleteFile).then(success => {
                    if (success.Success) {
                        this.file = null;
                        this.updatePageData();
                        this.deleteFile = false;
                    }
                });
            }
          
          });
            this.addOrEditClient = false; 
        }
      })
          .catch(err => { this.displayErrorMessage(err.Message); });
      }

      
      
  }

  private onCancel(): void {
    this.addOrEditClient = false;
  }

  @Watch('addOrEditClient')
  onDialogValueChanged(newVal: boolean): void {
    if (!newVal) {
      this.resetAll();
    }
  }

  private resetAll(): void {
    this.defaultClient = {};
    this.formElement.resetValidation();
  }

  updatePageData(): void {
    this.$nextTick(() => {
      this.tableLoading = true;
    });

    this.clientService.getClients({
      pageNumber: this.pageNumber,
      pageSize: this.pageSize,
      searchBy: this.selectedClientFilter
    })
    .then(success => {
        this.pagedData = success;
    })
    .finally(() => {
      this.tableLoading = false;
    });
  }
}
